import React, { FC } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/virtual";
import "swiper/css/scrollbar";

export type ItemType = {
  id: number;
  name: string;
};
export type ItemRendererType = (item: ItemType) => React.ReactNode;

export type CustomSwiperType = {
  items: Array<ItemType>;
  itemRenderer: ItemRendererType;
  breakpoints: SwiperBreakpointsType;
  scrollbar: boolean;
  slidesPerView: number;
};

type SwiperBreakpointsType = {
  [key: number]: {
    slidesPerView: number;
    spaceBetween?: number;
  };
};

const CustomSwiper: FC<CustomSwiperType> = ({
  items,
  itemRenderer,
  breakpoints,
  scrollbar,
  slidesPerView,
}) => {
  return (
    <Swiper
      breakpoints={breakpoints}
      observer={true}
      observeParents={true}
      style={{
        overflow: "hidden",
        width: "100%",
      }}
      navigation
      pagination={{ clickable: true }}
      scrollbar={scrollbar}
      spaceBetween={8}
      slidesPerView={slidesPerView}
    >
      {items.map((item: any, index: number) => {
        return <SwiperSlide key={index}>{itemRenderer(item)}</SwiperSlide>;
      })}
    </Swiper>
  );
};

export default CustomSwiper;
